import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import SearchSelect from "components/common/SearchSelect";
import PlanogramData from "components/menu/master-files/planogram-maintenance/planogram-data";
import PlanogramLayout from "components/menu/master-files/planogram-maintenance/planogram-layout";
import { findItemValueByIdFromArray } from "functions/find-item-by-id-from-array";
import {
    getPlanogramList
} from "api/menu/master-files/planogram-maintenance/actions";

class PlanogramTabs extends React.PureComponent {
    tabs = {
        data: "data",
        layout: "layout"
    };

    constructor(props) {
        super(props);

        this.state = {
            needRedirect: false,
            planogramId: parseInt(this.props.match.params.planogramId, 10)
        };

        if (!Object.keys(this.props.planogramList).length) {
            this.props.getPlanogramList();
        }
    }

    componentWillReceiveProps(nextProps) {
        const currentPlanogramId = parseInt(this.props.match.params.planogramId, 10);
        const nextPlanogramId = parseInt(nextProps.match.params.planogramId, 10);
        if (currentPlanogramId !== nextPlanogramId) {
            this.setState({
                planogramId: nextPlanogramId,
                needRedirect: false
            });
        }
    }

    render() {
        const { planogramList } = this.props;
        const { planogramId, needRedirect } = this.state;

        if (needRedirect) {
            return <Redirect to={`/planogramMaintenance/${planogramId}`} />;
        }

        const options = planogramList.map(item => ({
            label: item.planogramCode,
            value: item.planogramId
        }));
        const currentOption = findItemValueByIdFromArray(
            options,
            "value",
            planogramId
        ) || null;

        return (
            <div className="position-relative dashboard">
                <div
                    className="position-absolute w-25 d-flex"
                    style={{ right: 0 }}
                >
                    <div className="flex-fill mr-2">
                        <SearchSelect
                            className="custom-react-select"
                            options={options}
                            isLoading={false}
                            isClearable={false}
                            isSearchable={true}
                            value={currentOption}
                            onChange={option => this.setState({
                                planogramId: option.value,
                                needRedirect: true
                            })}
                        />
                    </div>
                    <a
                        href="/planogramMaintenance"
                        className="btn btn-danger"
                    >
                        Cancel
                    </a>
                </div>

                <Tabs
                    id="planogram-tabs"
                    defaultActiveKey={this.tabs.data}
                    className="w-100"
                    unmountOnExit={true}
                >
                    <Tab eventKey={this.tabs.data} title="Data">
                        <PlanogramData planogramId={planogramId} />
                    </Tab>
                    <Tab eventKey={this.tabs.layout} title="Layout">
                        <PlanogramLayout planogramId={planogramId} />
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.planogramMaintenance.loading,
    planogramList: state.planogramMaintenance.planogramList,
});

const mapStateToDispatch = dispatch => ({
    getPlanogramList: bindActionCreators(getPlanogramList, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(PlanogramTabs);
